import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity, Modal, ScrollView, Pressable } from "react-native"


import tw from '../../../styles/tailwind';
import Text from '../../../components/Text';
import RenderHtml from 'react-native-render-html';
import { useWindowDimensions } from 'react-native';
import api from '../../../utils/api';
import useActiveResidentCommunity from '../../../hooks/useActiveResidentCommunity';
import { useQuery } from '@tanstack/react-query';
import IconButton from '../../../components/IconButton';
import useFormSubmit from '../../../hooks/useFormSubmit';
import { SafeAreaView } from 'react-native-safe-area-context';


const TermsCheckbox = ({ onPress, checked }) => {

  return (
    <Pressable
      onPress={() => {
        onPress(!checked)
      }}
      style={
        tw.style(`flex-row items-center p-4 rounded-lg border`,
        checked ? tw`border-secondary` : tw`border-secondary/50`)
      }
    >
      <View
        style={
          tw.style(`w-6 h-6 rounded-lg mr-3 justify-center items-center`,
          checked ? `bg-secondary` : `bg-white/30 border border-gray-400`)
        }
      >
        {checked && (
          <View style={tw`w-3 h-3 bg-white rounded-full`} />
        )}
      </View>
      <Text style={tw`text-secondary`}>Acepto los términos y condiciones</Text>
    </Pressable>
  );
};


export default function AcceptToSModal({ onToSAccepted }) {
  const [checked, setChecked] = useState(false);
  const { width } = useWindowDimensions();

  const { communityId } = useActiveResidentCommunity()

  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ['resident.community.tos', communityId],
    queryFn: () => api.get(`/communities/${communityId}/tos`).then(response => response.data),
  })

  
  const { submitForm, isSubmitting } = useFormSubmit({
    onSuccess: onToSAccepted,
    onError: (error) => { },
    successToastMessage: "Términos aceptados",
    endpoint: `/communities/${communityId}/tos`,
  })




  return (
    <Modal
      visible
      style={tw.style()}
      animationType={"slide"}
    >
      <SafeAreaView style={tw`flex-1 bg-primary`}>
      <ScrollView style={tw`flex-1`} contentContainerStyle={tw`px-5 py-6`}>
        <RenderHtml
          contentWidth={width}
          source={{ html: data?.tos}}
        />

        {
          data?.tos &&
            <View style={tw`py-5`}>
              <TermsCheckbox onPress={checked => setChecked(checked)} checked={checked} />

              <IconButton
                style={tw`py-5 mt-8 bg-secondary rounded-lg`}
                disabled={!checked || isSubmitting}
                title={isSubmitting ? 'Enviando...' : 'Continuar'}
                icon={null}
                onPress={() => submitForm({})}
              />
            </View>
        }
      </ScrollView>
      </SafeAreaView>
    </Modal>
  )
}

